import {v4 as uuidv4} from "uuid";
import {faker}  from "@faker-js/faker";
import { isArrayWithLength } from "../../utils/array-methods";
import {
  getCurrentDateTime,
  getNextMonthFromCurrentDate,
} from "../../utils/convert-date";
import {
  PRODUCT_ID_DNC,
  PRODUCT_ID_WMS,
  PRODUCT_ID_WMA,
  PRODUCT_ID_WMC,
} from "../../utils/subscription-plan";

const productCatalog = {
  Products: [
    {
      DisplayOrder: 0,
      Features: [
        "Full visibility into cloud footprint",
        "View and organize cloud resources by business structure",
        "Security posture assessment (200+ checks)",
        "Compliance assessment (160+ checks)",
        "Actionable recommendations to save on cloud costs",
      ],
      MetaData: { Code: "dnc" },
      Plans: [
        {
          Billed: "Monthly",
          Cost: 0.0,
          Currency: "USD",
          CurrencyCode: "$",
          PlanId: "dnc-m-v1",
          PlanName: "DNC Monthly",
          ProductId: null,
          Revision: "v1",
          Status: "Active",
          Type: "Monthly",
        },
        {
          Billed: "Monthly",
          Cost: 0.0,
          Currency: "USD",
          CurrencyCode: "$",
          PlanId: "dnc-y-v1",
          PlanName: "DNC Yearly",
          ProductId: null,
          Revision: "v1",
          Status: "Active",
          Type: "Yearly",
        },
      ],
      ProductDescription:
        "Includes cost saving insights, Security, Compliance assessment",
      ProductId: PRODUCT_ID_DNC,
      ProductName: "Discovery & Classification",
      ProductType: "Free",
      Status: "Active",
    },
    {
      DisplayOrder: 1,
      Features: [
        "Build cloud accounts with well architected principles & AWS best practices",
        "Rich library of CloudOps Automation tasks",
        "Cloud cost management",
        "Governance guardrails for self-service provisioning",
        "Remediations for security and compliance findings",
      ],
      MetaData: { Code: "wmc" },
      Plans: [
        {
          Billed: "Monthly",
          Cost: 500.0,
          Currency: "USD",
          CurrencyCode: "$",
          PlanId: "wmc-m-v1",
          PlanName: "WMC Monthly",
          ProductId: null,
          Revision: "v1",
          Status: "Active",
          Type: "Monthly",
        },
        {
          Billed: "Monthly",
          Cost: 5000.0,
          Currency: "USD",
          CurrencyCode: "$",
          PlanId: "wmc-y-v1",
          PlanName: "WMC Yearly",
          ProductId: null,
          Revision: "v1",
          Status: "Active",
          Type: "Yearly",
        },
      ],
      ProductDescription: "",
      ProductId: PRODUCT_ID_WMC,
      ProductName: "Well Managed Cloud",
      ProductType: "Paid",
      Status: "Active",
    },

    {
      DisplayOrder: 2,
      Features: [
        "Manage Windows & Linux Servers in hybrid, multi-cloud environments",
        "Server up/down time scheduling",
        "Patch compliance",
        "Desired state management",
        "One-click remote server access (No bastion hosts /SSH keys, fully audited)",
      ],
      MetaData: { Code: "wms" },
      Plans: [
        {
          Billed: "Monthly",
          Cost: 20.0,
          Currency: "USD",
          CurrencyCode: "$",
          PlanId: "wms-m-v1",
          PlanName: "WMS Monthly",
          ProductId: null,
          Revision: "v1",
          Status: "Active",
          Type: "Monthly",
        },
        {
          Billed: "Monthly",
          Cost: 200.0,
          Currency: "USD",
          CurrencyCode: "$",
          PlanId: "wms-y-v1",
          PlanName: "WMS Yearly",
          ProductId: null,
          Revision: "v1",
          Status: "Active",
          Type: "Yearly",
        },
      ],
      ProductDescription: "",
      ProductId: PRODUCT_ID_WMS,
      ProductName: "Well Managed Servers",
      ProductType: "Paid",
      Status: "Active",
    },
    {
      DisplayOrder: 3,
      Features: [
        "Create operations-ready cloud resources and server based, serverless or containerized application environments in few clicks",
        "Application monitoring",
        "Application maintenance automation",
        "Secure file storage",
        "Rules based automatic issue detection, alerting, ticketing and remediation",
      ],
      MetaData: { Code: "wma" },
      Plans: [
        {
          Billed: "Monthly",
          Cost: 190.0,
          Currency: "USD",
          CurrencyCode: "$",
          PlanId: "wma-m-v1",
          PlanName: "WMA Monthly",
          ProductId: null,
          Revision: "v1",
          Status: "Active",
          Type: "Monthly",
        },
        {
          Billed: "Monthly",
          Cost: 1900.0,
          Currency: "USD",
          CurrencyCode: "$",
          PlanId: "wma-y-v1",
          PlanName: "WMA Yearly",
          ProductId: null,
          Revision: "v1",
          Status: "Active",
          Type: "Yearly",
        },
      ],
      ProductDescription: "",
      ProductId: PRODUCT_ID_WMA,
      ProductName: "Well Managed Applications",
      ProductType: "Paid",
      Status: "Active",
    },
  ],
  SupportedPaymentMethod: [
    { ID: "CRD", Label: "Credit Card" },
    { ID: "PO", Label: "Purchase Order" },
  ],
};

export const subscriptionProductCatalog = () => {
  let productCatalogData = [],
    paymentype = [],
    product = {};
  productCatalog.SupportedPaymentMethod.forEach((payment) => {
    const paymentList = {
      ...payment,
    };
    paymentList.ID = payment.ID ? payment.ID : uuidv4();
    paymentype.push(paymentList);
  });
  product.SupportedPaymentMethod = paymentype;
  productCatalog.Products.forEach((product) => {
    const data = {
      ...product,
    };
    let plansData = [];
    product.Plans.forEach((plan) => {
      const planList = {
        ...plan,
      };
      planList.PlanId = plan.PlanId ? plan.PlanId : uuidv4();
      plansData.push(planList);
    });

    data.ProductId = product.ProductId
      ? product.ProductId
      : uuidv4();
    data.Plans = plansData;
    productCatalogData.push(data);
  });
  product.Products = productCatalogData;
  return product;
};

const subscription = {
  AutoRenew: true,
  IsTrial: false,
  PaymentType: "PO",
  Plans: [
    {
      AutoRenew: true,
      BillingStartDate: "2021-02-01 23:00:00",
      CreatedAt: "2021-02-03 05:34:20",
      EndDate: "2021-03-01 01:00:00",
      Id: "19c1edbe-68a8-4326-a720-872f28bb6c61",
      IsActive: true,
      Metadata: {},
      ModifiedAt: null,
      PGSubscriptionItemId: null,
      PlanId: "dnc-m-v1",
      Price: 0.0,
      ProductId: PRODUCT_ID_DNC,
      StartDate: "2021-02-01 23:00:00",
      Status: "Active",
    },
    {
      AutoRenew: true,
      BillingStartDate: "2021-02-01 23:00:00",
      CreatedAt: "2021-02-03 05:34:20",
      EndDate: "2021-03-01 01:00:00",
      Id: "303abe39-147f-48b3-8384-8ebe74eb7ba2",
      IsActive: true,
      Metadata: {},
      ModifiedAt: null,
      PGSubscriptionItemId: null,
      PlanId: "wma-m-v1",
      Price: 190.0,
      ProductId: PRODUCT_ID_WMA,
      StartDate: "2021-02-01 23:00:00",
      Status: "Active",
    },
    {
      AutoRenew: true,
      BillingStartDate: "2021-02-01 23:00:00",
      CreatedAt: "2021-02-03 05:34:20",
      EndDate: "2021-03-01 01:00:00",
      Id: "cf794e76-6409-4bd7-8035-1783ef398994",
      IsActive: true,
      Metadata: {},
      ModifiedAt: null,
      PGSubscriptionItemId: null,
      PlanId: "wms-m-v1",
      Price: 20.0,
      ProductId: PRODUCT_ID_WMS,
      StartDate: "2021-02-01 23:00:00",
      Status: "Active",
    },
    {
      AutoRenew: true,
      BillingStartDate: "2021-02-01 23:00:00",
      CreatedAt: "2021-02-03 05:34:20",
      EndDate: "2021-03-01 01:00:00",
      Id: "cf794e76-6409-4bd7-8035-1783ef398995",
      IsActive: true,
      Metadata: {},
      ModifiedAt: null,
      PGSubscriptionItemId: null,
      PlanId: "wmc-m-v1",
      Price: 20.0,
      ProductId: PRODUCT_ID_WMC,
      StartDate: "2021-02-01 23:00:00",
      Status: "Active",
    },
  ],
  Status: "Active",
  SubscriptionId: "47dc2e84-3197-49b3-901e-4014d2b7ba8d",
  SubscriptionType: "Standard",
  Tenure: "Monthly",
  Metadata: {
    EnterpriseRequest: false,
  },
};

export const subscribedPlans = () => {
  let subscribedPlan = {},
    Plans = [];
  isArrayWithLength(subscription.Plans) &&
    subscription.Plans.forEach((p) => {
      let PlanData = {
        ...p,
        EndDate: getNextMonthFromCurrentDate(),
        BillingStartDate: getCurrentDateTime(),
      };
      Plans.push(PlanData);
    });
  subscribedPlan = {
    ...subscription,
    Plans,
  };
  return subscribedPlan;
};
